/**
 * Clock times for display.
 *
 * The API works in 24-hour `HH:MM` throughout — unambiguous to parse, and
 * what the planner's arithmetic uses. This is the one place it is turned into
 * something to read, so the two never drift apart.
 */

/** "09:02" → "9:02 AM". Returns the input unchanged if it is not a clock time. */
export function formatClock(value: string): string {
  const match = /^(\d{1,2}):(\d{2})$/.exec(value.trim());
  if (!match) return value;

  const hours = Number(match[1]);
  const minutes = match[2];
  if (!Number.isFinite(hours) || hours > 23) return value;

  const suffix = hours < 12 ? 'AM' : 'PM';
  // 0 and 12 both display as 12 — midnight and noon, not "0" and "0 PM".
  const display = hours % 12 === 0 ? 12 : hours % 12;
  return `${display}:${minutes} ${suffix}`;
}
